/* eslint-disable no-shadow */
export enum ToastType {
  None,
  Info,
  Warning,
  Error,
  Success,
}
